var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Layout',[_c('PageHeader',{attrs:{"title":_vm.title,"items":_vm.breadCrumbs,"prev":{name:'',params:{}},"backButton":_vm.showBackButton}}),_c('router-view',{on:{"show-toast":_vm.openToast}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }